import * as TYPES from "../constants"
import { store } from "store"
import { BreadcrumbType } from "components/Breadcrumb"

export const setLoader = (value: boolean) => ({ type: TYPES.SET_LOADER, value })
export const setTitle = (value: string) => ({ type: TYPES.SET_TITLE, value })
export const setUser = (value: object) => ({ type: TYPES.SET_USER, value })
export const setToken = (value: string) => ({ type: TYPES.SET_TOKEN, value })
export const setLogout = () => ({ type: TYPES.SET_LOGOUT })
export const setStaffModal = (value: any) => ({
	type: TYPES.SET_STAFF_DIALOG,
	value,
})
export const setBreadcrumb = (value: BreadcrumbType | null) => ({
	type: TYPES.SET_BREADCRUMB,
	value,
})
export const updateCrumb = () => ({ type: TYPES.UPDATE_CRUMB })
export const setUpdater = (dispatch: any) => ({
	type: TYPES.SET_UPDATER,
	dispatch,
})
export const setLogsFilters = (value: object) => ({
	type: TYPES.SET_LOGS_FILTERS,
	value,
})
export const setOrders = (value: object) => ({
	type: TYPES.SET_ORDERS,
	value,
})
export const setTemporaryOrders = (value: object) => ({
	type: TYPES.SET_TEMPORARY_ORDERS,
	value,
})
export const setOrdersToAggregate = (value: object) => ({
	type: TYPES.SET_ORDERS_TO_AGGREGATE,
	value,
})
export const setOrderFilters = (value: object) => ({
	type: TYPES.SET_ORDER_FILTERS,
	value,
})
export const setOrdersTab = (value: string) => ({
	type: TYPES.SET_ORDERS_TAB,
	value,
})
export const setLanguage = (value: string | null) => ({
	type: TYPES.SET_LANGUAGE,
	value,
})
export const setPageSize = (value: number | null) => ({
	type: TYPES.SET_PAGE_SIZE,
	value,
})

export const delayedDispatch = (value: any, time = 400) => {
	setTimeout(() => store.dispatch(value), time)
}

export const setNotificationToken = (value: string) => ({
	type: TYPES.SET_NOTIFICATION_TOKEN,
	value,
})

export const setFilters = (value: object) => ({
	type: TYPES.SET_FILTERS,
	value,
})

export const setOperationLinksViewMode = (value: "card" | "list") => ({
	type: TYPES.SET_OPERATION_LINKS_VIEW_MODE,
	value,
})

export const setOperationLinksCollapsedGroups = (
	value: Record<string, boolean>
) => ({
	type: TYPES.SET_OPERATION_LINKS_COLLAPSED_GROUPS,
	value,
})

export const setRoutesTableWidth = (value: number) => ({
	type: TYPES.SET_ROUTES_TABLE_WIDTH,
	value,
})

export const setRoutesPageSize = (value: number | null) => ({
	type: TYPES.SET_ROUTES_PAGE_SIZE,
	value,
})

export const setOrdersTableWidth = (value: number) => ({
	type: TYPES.SET_ORDERS_TABLE_WIDTH,
	value,
})

export const setOrdersStatusFilter = (value: string[]) => ({
	type: TYPES.SET_ORDERS_STATUS_FILTER,
	value,
})

export const setOrderGlobalInfo = (value: object) => ({
	type: TYPES.SET_ORDER_GLOBAL_INFO,
	value,
})

export const setSidebarOpenGroups = (value: Record<string, boolean>) => ({
	type: TYPES.SET_SIDEBAR_OPEN_GROUPS,
	value,
})
